// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_u0-0";